import * as angular from 'angular';
import { bind } from 'app/_decorators/bind.decorator';

class RuntimeIsBetweenValidator implements ng.IDirective {
    public require = 'ngModel';
    public restrict = 'A';
    public scope = false;
    private compareRuntime: DateInterval;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        element: JQuery,
        attributes: ng.IAttributes,
        ngModelCtrl: ng.INgModelController
    ) => {
        ngModelCtrl.$validators['pkpRuntimeIsBetweenValidator'] = this.validate;

        scope.$watch(
            () => {
                return scope.$eval(attributes['compareRuntime']);
            },
            (newRuntime: DateInterval) => {
                this.compareRuntime = newRuntime;
                ngModelCtrl.$validate();
            },
            true
        );
    };

    @bind
    private validate(modelValue: any, viewValue: any): boolean {
        if (!modelValue || !this.compareRuntime) {
            return true;
        }

        if (
            !!modelValue.start &&
            !!this.compareRuntime.start &&
            moment(modelValue.start).isBefore(this.compareRuntime.start)
        ) {
            return false;
        }

        if (
            !!modelValue.end &&
            !!this.compareRuntime.end &&
            moment(modelValue.end).isAfter(this.compareRuntime.end)
        ) {
            return false;
        }

        return true;
    }
}

angular
    .module('app')
    .directive(
        'pkpRuntimeIsBetweenValidator',
        () => new RuntimeIsBetweenValidator()
    );
